import {IAcceptor} from "../../../models/acceptor/IAcceptor";
import {Ic} from "../../../models/common";
import {
  TOPOLOGY_BUCK,
  TOPOLOGY_FLYBACK, TOPOLOGY_HPF_QR_FLYBACK, TOPOLOGY_ISOLATED_FLYBACK, TOPOLOGY_NON_ISOLATED_FLYBACK,
  TOPOLOGY_PFC_BOOST,
  TOPOLOGY_QR_FLYBACK
} from "../../../models/view";
import {Acceptor_Common} from "../../../models/acceptor/acceptor_common";
import {IValidator} from "../../../models/validator/IValidator";
import {Validator_Common} from "../../../models/validator/validator_common";
import {isNull} from "util";
import {Validator_AcDc_QR_Flyback} from "./validator/acdc_qr_flyback_validator";
import {Validator_AcDc_PFC_Boost} from "./validator/acdc_pfc_boost_validator";
import {Validator_AcDc_Flyback} from "./validator/acdc_flyback_validator";
import {Validator_AcDc_ViperBuck} from "./validator/acdc_viperbuck_validator";
import {IComparator} from "../../../models/IComparator";
import {Comparator_AcDc} from "./comparator";
import {IUpdateDesign, UpdateDesign} from "../../../models/IUpdateDesign";
import {IAppFactoryService} from "../../../Redux/selector.state";
import {Feature} from "../../../models/features/features";
import {Acceptor_AcDc_QR_Flyback} from "./acceptor/acdc_qr_flyback_acceptor";
import {Acceptor_AcDc_PFC} from "./acceptor/acdc_pfc_acceptor";
import {Acceptor_AcDc_Flyback} from "./acceptor/acdc_flyback_acceptor";
import {Acceptor_AcDc_Buck} from "./acceptor/acdc_buck_acceptor";

/**
 * Created by claudio iozzia on 28/06/2017.
 */

export class AcDc_Factory {

  private static createAcceptor(a: Ic): IAcceptor {
    // a:Ic cannot be never null
    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_QR_FLYBACK:
      case TOPOLOGY_HPF_QR_FLYBACK:
        // // this is never used till now no viperX5 in catalog!!
        // if (["viper15", "viper25"].findIndex(x=>a.ic.CPN.toLowerCase().startsWith(x))) {
        //   return new Acceptor_AcDc_ViperX5();
        // }
        return new Acceptor_AcDc_QR_Flyback();
      case TOPOLOGY_PFC_BOOST:
        return new Acceptor_AcDc_PFC();
      case TOPOLOGY_FLYBACK:
      case TOPOLOGY_ISOLATED_FLYBACK:
      case TOPOLOGY_NON_ISOLATED_FLYBACK:
        return new Acceptor_AcDc_Flyback();
      // case TOPOLOGY_BOOST:
      //   return new Acceptor();
      // case TOPOLOGY_BUCK_BOOST:
      //   return new Acceptor_Common();
      case TOPOLOGY_BUCK:
        return new Acceptor_AcDc_Buck();
      default:
        return new Acceptor_Common();

    }
  }

  private static createUpdateDesign(a: Ic): IUpdateDesign {
    return new UpdateDesign();
  }

  private static createComparator(): IComparator {
    return new Comparator_AcDc();
  }

  private static createValidator(a: Ic): IValidator {

    if (!a) {
      return new Validator_Common();
    }

    switch (a.topology.toLowerCase()) {
      case TOPOLOGY_QR_FLYBACK:
      case TOPOLOGY_HPF_QR_FLYBACK:
        return new Validator_AcDc_QR_Flyback();
      // // this is never used till now no viperX5 in catalog!!
      // if (["viper15", "viper25"].findIndex(x=>a.ic.CPN.toLowerCase().startsWith(x))) {
      //     return new Validator_AcDc_ViperX5();
      // }
      case TOPOLOGY_PFC_BOOST:
        return new Validator_AcDc_PFC_Boost();
      case TOPOLOGY_FLYBACK:
      case TOPOLOGY_ISOLATED_FLYBACK:
      case TOPOLOGY_NON_ISOLATED_FLYBACK:
        return new Validator_AcDc_Flyback();
      // case TOPOLOGY_BOOST:
      // case TOPOLOGY_BUCK_BOOST:
      //  return new Validator_AcDc_BuckBoost()
      default:
        return new Validator_AcDc_ViperBuck();
    }
  }

  private static createStdFeature(): Feature[] {
    return [];
  }

  public static createService(): IAppFactoryService {
    return {
      acceptorCreator: AcDc_Factory.createAcceptor,
      updateDesignCreator: AcDc_Factory.createUpdateDesign,
      comparator: AcDc_Factory.createComparator(),
      validatorCreator: AcDc_Factory.createValidator,
      stdFeatures: AcDc_Factory.createStdFeature()
    };
  }

}
